import { useMemo } from 'react';
import { getColor } from 'common/constants/_colors';
import { MONTE_CARLO_BENCHMARKS } from '../chart.utils';
import { round } from 'lodash';

const generatePlotLine = ({ text, value }) => ({
  color: getColor('silverSand'),
  width: 2,
  dashStyle: 'shortdot',
  value,
  label: {
    text,
    useHTML: true
  }
});

const useChartPlotLines = ({ chartData }) => {
  const plotLines = useMemo(() => {
    if (!chartData?.length) return [];

    const plotLines = [];

    for (let i = 0; i < chartData.length - 1; i++) {
      const currProbability = chartData[i].totalProbability;
      const nextProbability = chartData[i + 1].totalProbability;

      for (const benchmark of MONTE_CARLO_BENCHMARKS) {
        if (currProbability <= benchmark && nextProbability >= benchmark) {
          const text = `${round(benchmark * 100)}%`;
          plotLines.push(generatePlotLine({ text, value: i + 0.5 }));
          break;
        }
      }
    }

    return plotLines;
  }, [chartData]);

  return plotLines;
};

export default useChartPlotLines;
